import { type FC } from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	onPress: () => void;
	label: string;
	selected: boolean;
}

const Tag: FC<Props> = ({ onPress, label, selected }) => {
	return (
		<TouchableOpacity
			accessibilityRole="button"
			accessibilityState={{ selected }}
			activeOpacity={Dimens.opacity80}
			onPress={onPress}
		>
			<View style={[styles.filters, selected && styles.filtersSelected]}>
				<Text style={[styles.filtersText, selected && styles.filtersSelectedText]}>{label}</Text>
			</View>
		</TouchableOpacity>
	);
};

const styles = StyleSheet.create({
	filters: {
		height: Dimens.size28,
		justifyContent: 'center',
		backgroundColor: Colors.white,
		borderRadius: Dimens.borderRadiusPill,
		paddingHorizontal: Dimens.padding12,
	},
	filtersSelected: {
		backgroundColor: Colors.green700,
	},
	filtersText: {
		fontFamily: Fonts.barlowMedium,
		fontSize: Dimens.fontSize12,
		lineHeight: Dimens.lineHeight16,
		color: Colors.gray750,
	},
	filtersSelectedText: {
		color: Colors.white,
	},
});

export default Tag;
